import * as Yup from "yup";

const validationSchema = Yup.object().shape({
  refundLearner: Yup.boolean(),
});

export default validationSchema;
